

import React from "react";
import AddToQueueIcon from '@mui/icons-material/AddToQueue'; // Updated import for MUI 5

import { bindActionCreators } from 'redux';
import * as StudyActions from '../../../../../../reducers/study_actions';
import * as SidebarActions from '../../../../../../../../components/SideNavigation/sidebar_actions';
import { connect } from 'react-redux';
import AddAnalysisDialog from '../../../side-panels/study-store/components/add-analysis-dialog/AddAnalysisDialog';
import { GPAP_Button } from '../../../../../../../../gpap-lib/components/Button_Collection';
import MappedText from '../../../../../../../study-page/create-study/analysis-page/components/clinical-info/mapText';
import {useState} from "react";



function AddAnalysisButton(props){

    const [analysisOpen, setAnalysisOpen] = useState(false);

    const onClose = () =>{
        setAnalysisOpen(false)
    }

    // hide it for now;
    if(window.config.instand){
        return null;
    }
    else{
        return <React.Fragment>
            <AddAnalysisDialog
                open={analysisOpen}
                setClose = { onClose }
                queryRunner={props.queryRunner}
                instandGeneticFindingsTab={props.instandGeneticFindingsTab}
            />
            <GPAP_Button
                id={"newAnalysis"}
                variant="contained"
                style={{margin: "0.5%", float: "left"}}
                onClick={() => setAnalysisOpen(true)}
                startIcon={<AddToQueueIcon/>}><MappedText text={"New Analysis"} /></GPAP_Button>
        </React.Fragment>
    }




}



// to send data from MainPanel component to the Store;
const mapDispatchToProps = (dispatch) => ({
    studyActions: bindActionCreators(StudyActions, dispatch),
    sidebarActions: bindActionCreators(SidebarActions, dispatch)
});


export default connect(null, mapDispatchToProps)(AddAnalysisButton);